export default "__VITE_ASSET__6842a74f__"